import { useRef, useEffect } from "react";
import { useCustomSession } from "shared/context/CustomSessionContext";
import { DelayedPromise } from "shared/helpers/DelayedPromise";

export const useAuthentification = () => {
  const session = useCustomSession();
  const pendingRef = useRef<DelayedPromise<void>>(new DelayedPromise());

  const isAuthenticated = !!session?.profileId;

  const waitForAuthentification = async () => {
    return await pendingRef.current.promise;
  };

  useEffect(() => {
    if (isAuthenticated) {
      pendingRef.current.resolve();
    } else {
      pendingRef.current = new DelayedPromise();
    }
  }, [isAuthenticated]);

  return {
    isAuthenticated,
    waitForAuthentification,
  };
};
